// extracted by mini-css-extract-plugin
export default {"buttonContainer":"LandingFeaturedArt_buttonContainer__Kh79x"};